<template src="./registration.html"></template>

<script>
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'

export default {
    name: "reginserMember",
    data() {
        return {
            manager:null, //  담당자 보류
            ko : ko,
            // 기본정보
            state : 'verified', // 가입 상태 - 인증
            role: 'licensor',
            email: null,
            language: null,
            reference: 'other',
            marketing: true,
            notification_album : false,
            notification_sales : true,
            roleOption: [
              {value: 'licensor', label: 'Licensor'},
              {value: 'contractor', label: 'Contractor'},
              // {value: 'user', label: 'User'}, user type 미사용
              {value: 'admin', label: 'Admin'},
            ],
            langOption: optionData.lang,
            referenceOption:optionData.reference,
            bankOption: optionData.bank,
            bankNameCode : null,
            sr_representative : null,
      
            managerList : [],

            entityOption : optionData.entity,
            countryOption : optionData.country,
            dialingOption : optionData.dialing,
            paymentOption : optionData.payment,
            currencyOption: optionData.currency,
            identificationOtion: [
              {value: 'kr_resident', label: '주민등록번호'},
              {value: 'kr_business', label: '사업자등록번호'},
              {value: 'foreign_tax', label: 'Tax No.'},
            ],
            
            object :{
              
              bankaccount:{
                payoneer_activation_date: null,
                payoneer_customer_id: null,
                payoneer_payee_id: null,
                paypal_email : null,
                account_number: null,
                bank_branch: null,
                bank_name: null,
                bank_code : null,
                name: null,
                payment_method: null,
                address : {
                  address_line: null,
                  address_line2: null,
                  city: null,
                  district: null,
                  postal_code: null,
                }
              },
              contract_end_date: null,
              contract_start_date: null,
              default_service_fee_kr: 15,
              default_service_fee_other: 15,
              company: null,
              currency: null,
              entity: null,
              ddex_partyid: null,  
              entity_address: {
                address_line: null, // 거주 주소
                address_line2: null, // 거주 주소
                country: null, // 거주 국가
                postal_code: null, // 거주 우편번호
              },
              entity_date: null,
              entity_identification: null,
              entity_identification_type: null,
              entity_tax_exemption: false,
              family_name: null,
              given_name: null,
              mims_account: null,
              nationality: null,
              phone: null,
              phone_countrycode: null,
            },

            defaultPagination: 1,                         // BasePagination
            files: [],              // 파일 데이터
            modals: {
                modal3: true,
                modal4: false,
                modal5: false,
                modal6: false,
                modal7: false,
                modal8: false,
            },
           
            memo: {
              listData: [],                  // 메모 리스트데이터
              total_page: 0,                 // 메모 리스트 총 페이징
              pagination: 1,                 // 메모 리스트 페이징
              data: {
                memo_model: null,
                filter :{
                  memo : {
                    sort: 'updated_at',
                    sortorder: 'desc',
                    page: 0,
                    limit: 20
                  },
                },
                page: {
                  memo: {
                    total_page: 0,                 // 메모 총 페이징
                    pagination: 1,                 // 메모 페이징
                  },
                },
              },
              limit_box: {
                limit_model: 10,
                limit: [ // 리스트 제한갯수
                  {value: 10, label: "10"},
                  {value: 20, label: "20"},
                  {value: 30, label: "30"},
                  {value: 50, label: "50"},
                ],
              },
            }
        }
    },
    mounted(){
      this.$nextTick((vue) =>{
        this.managerCall();
      })
    },
    computed: {
      memo_totalPage(){
        return this.memo.data.page.memo.totalPage
      },
      memo_pagination(){
        return this.memo.data.page.memo.pagination
      },
      state_conversion() {
        switch(this.state) {
          case "verified":
            return "인증";
          case "not_verfied":
            return "사업자등록번호";
          case "disabled":
            return "탈퇴";
        }
      }
    },
    watch:{
      'role'(){
        if(this.role == 'user'){
          this.object = {
            ...optionData.userObject
          }
          this.bankNameCode = null
        }else if(this.role == 'licensor'){
          this.object.default_service_fee_kr = 15
          this.object.default_service_fee_other = 15
        }else {
          this.object.default_service_fee_kr = 50
          this.object.default_service_fee_other = 50
        }
        
      },
      'object.nationality'(){
        if(this.object.nationality != 'KR'){
          this.object.mims_account =''
        }
      },
      'object.entity'(){
        if(this.object.entity != 'corporation'){
        
          this.object.entity_identification_type = 'kr_resident'
          this.object.company = null
          this.object.entity_tax_exemption = false
        }else{
          this.object.entity_identification_type = 'kr_business'
          
        }
        if(this.object.entity_address.country != 'KR'){
          this.object.entity_identification_type = 'foreign_tax'
        }
      },
      'object.entity_address.country'(data){
        if(this.object.entity_address.country == 'KR'){
          this.object.currency = 'krw'
          this.object.bankaccount.payment_method = 'kr_banktransfer'
          if(this.object.entity != 'corporation'){
             this.object.entity_identification_type = 'kr_resident'
          }else{
             this.object.entity_identification_type = 'kr_business'
          }
          //   {value: 'kr_resident', label: '주민등록번호'},
          //   {value: 'kr_business', label: '사업자등록번호'},
          //   {value: 'foreign_tax', label: 'Tax No.'},
        }else{
          this.object.entity_identification_type = 'foreign_tax'
          if(this.object.currency == 'krw') {
            this.object.currency = null
          }
          if(this.object.bankaccount.payment_method == 'kr_banktransfer'){
            this.object.bankaccount.payment_method = null
          }
        }
      },
      'object.bankaccount.payment_method'(){
        
      },
      bankNameCode(){
        if(this.bankNameCode != null){
          this.object.bankaccount.bank_code = this.bankNameCode.code
          this.object.bankaccount.bank_name = this.bankNameCode.name
        }
        
      },
      memo_pagination(){
        this.getMemoList()
      }
    },
    methods: {
    
      nullCheck(data){
        if(data == '' || data == null){
          return true
        }else{
          return false
        }
        
      },
      allNullCheck( checkList){
        let t = flatten(this.object)
        console.log(t);
        let msgList = {
          'entity' :'사업자구분을 선택해주세요.',
          'phone_countrycode' : '전화번호를입력해주세요.', 
          'phone' : '전화번호를입력해주세요.',
          'nationality' : '국가를 선택해주세요.',
          'company'  : '회사명을 입력해주세요.',
          'bankaccount.payment_method': '지급방법을 선택해주세요.' ,
          'entity_identification' : '납세자번호를 입력해주세요.',
          'currency' : '정산화폐를 선택해주세요.',
          'entity_address.country' : '거주국가를 선택해주세요.',
          'entity_date' : '생년월일(회사설립일을 입력해주세요.)',
          'entity_address.address_line':'거주지 주소를 입력해주세요.' ,
          'family_name': '성명을 모두 입력해주세요.' ,
          'given_name' : '성명을 모두 입력해주세요.',
          'default_service_fee_kr' : '국내정산요율을 입력해주세요',
          'default_service_fee_other' : '해외정산요율을 입력해주세요',
          'bankaccount.name' : '예금주를 입력해주세요.',
          'bankaccount.bank_code' : '은행코드를 입력해주세요.',
          'bankaccount.bank_name' :'은행명을 입력해주세요.' ,
          'bankaccount.bank_branch' : 'Bank Name을 입력해주세요',
          'bankaccount.account_number': '계좌번호를 입력해주세요',
          'bankaccount.address.address_line': 'Branch 주소를 입력해주세요.',
          'bankaccount.address.address_line2': 'Branch 상세주소를 입력해주세요.',
          'bankaccount.address.city': 'Branch City를 입력해주세요.',
          'bankaccount.address.district' : 'Branch District를 입력해주세요.',
          'bankaccount.address.postal_code' : 'Branch 우편번호를 입력해주세요.',
          'bankaccount.paypal_email' : 'PayPaY 계정 이메일을 입력해주세요.',
          'contract_end_date' : '계약 종료을 입력해주세요.', 
          'contract_start_date': '계약 시작일을 입력해주세요.',
        }
        for(var i in checkList){
          console.log(t[checkList[i]] )
          if(t[checkList[i]] == null || t[checkList[i]] == ''){
          
            this.alert({msg:msgList[checkList[i]]})
            return false;
          }
          
        }
        return true;
      },
      
    
      all_save(){
        
        this.closeModal('confirm')
        let params = {
          state : 'verified', // 가입 상태 - 인증
          role: this.role,
          email: this.email,
          language: this.language,
          reference: this.reference,
          marketing: true,
        }
        if(this.role != 'admin' ){
          params['sr_representative'] = this.sr_representative
        }
        let checkList = [];
        if(this.nullCheck(this.language)){
          this.alert({msg:'사이트 언어를 선택해주세요.'})
          return false;
        }
        if(this.nullCheck(this.email)){
          this.alert({msg:'이메일을 입력해주세요.'})
          
          return false;
        }
        let emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		    if (!emailReg.test(this.email)) { // 이메일 정규식 체크
          this.alert({msg:'이메일형식이 맞지 않습니다.'});
          return false;
        }
        if(this.role == 'admin'){
          if(!this.valCheck(this.admin_slack_id)){
          params['admin_slack_id'] = this.admin_slack_id
          }
          if(!this.valCheck(this.admin_nickname)){
            params['admin_nickname'] = this.admin_nickname
          }
        }
        if(this.role == 'licensor'){
            let licensor = { licensor :this.object }
            params = Object.assign(params, licensor)
            // 필요없는 property 삭제
            delete params.licensor.contract_start_date; 
            delete params.licensor.contract_end_date; 
            
            console.log(params)
            //라이센서 체크 리스트
            checkList = [
              'nationality',
              'entity',
              'family_name',
              'given_name',
              'entity_address.country',
              'currency',
              'bankaccount.payment_method',
              'entity_identification',
              'default_service_fee_kr',
              'default_service_fee_other',
              ]
            if(params.entity == "corporation"){
              checkList.push('company')
            }
            
        }else if(this.role == 'contractor'){
          // contractor check List 
          let contractor = { contractor : this.object}
          params = Object.assign(params, contractor)
          // 필요없는 property 삭제
          delete params.contractor.ddex_partyid; 
          delete params.contractor.mims_account; 
          
          checkList = [
              'nationality',
              'family_name',
              'given_name',
              'entity',
              'entity_address.country',
              'currency',
              'bankaccount.payment_method',
              'entity_identification',
              'default_service_fee_kr',
              'default_service_fee_other',
              'contract_end_date',
              'contract_start_date']
          if(params.entity == "corporation"){
            checkList.push('company')
          }
         
        }
          
        // 지급방법별 체크
        let checkList2 = []
        console.log(params);
        if(this.object.bankaccount.payment_method == 'kr_banktransfer'){
            checkList2 = [
              'bankaccount.name',
              'bankaccount.bank_code',
              'bankaccount.bank_name',
              'bankaccount.account_number',
            ]
            this.object.bankaccount.bank_branch = null
            this.object.bankaccount.paypal_email = null
            this.object.bankaccount.address = {
              address_line: null,
              address_line2: null,
              city: null,
              district: null,
              postal_code: null,
            }
          }
        if(this.object.bankaccount.payment_method == 'intl_banktransfer'){
          checkList2 = [
            'bankaccount.name',
            'bankaccount.bank_branch',
            'bankaccount.account_number',

            'bankaccount.address.address_line',
            // 해외 이체 시 주소 1만 입력
            // 'bankaccount.address.address_line2',
            // 'bankaccount.address.city',
            // 'bankaccount.address.district',
            // 'bankaccount.address.postal_code',
        ]
          this.object.bankaccount.bank_name = null
          this.object.bankaccount.paypal_email = null
        }
        if(this.object.bankaccount.payment_method == 'paypal'){
          checkList2 = [
              'bankaccount.paypal_email'
          ]
          this.object.bankaccount.name = null
          this.object.bankaccount.bank_code = null
            this.object.bankaccount.account_number = null
            this.object.bankaccount.address = {
            address_line: null,
            address_line2: null,
            city: null,
            district: null,
            postal_code: null,
          }
        }
        checkList = _.concat(checkList, checkList2);
        console.log(checkList)
        
        //라이센서 컨트랙터 필수값 체크
        
        if(checkList.length > 0 && !this.allNullCheck(checkList)){
          console.log(this.allNullCheck(checkList))
          return false
        }
        this.bankNameCode = null
        
        this.loadingShow()
        
        const payload = {params: params}

        this.$store.dispatch("POSTUSER", payload)
        .then(result =>{
          this.loadingHide();
          this.$vs.notify({text:'사용자가 정상적으로 등록 되었습니다.',position:'top-center'})
          this.$router.push({path: '/member'})
        }).catch(error =>{
          this.loadingHide();
          switch(error.response.data.code) {
            case 56:
              this.alert({
                msg : '이미 등록된 유저입니다.'
              }) 
              break;
            default:
              alert(error)
              break;
          }
        })
      },
      memo_save() {
        const payload = {
          role: this.role,
          id: this.licensor? this.licensor.id : this.contractor.id,
          data: this.memo.data.memo_model,
          filter: this.memo.data.filter.memo
        }
        this.$store.dispatch('POSTMEMO', payload)
        .then(result =>{
          this.getMemoList(payload)
          this.modals.modal7 = false
        })
      },
      getMemoList(payload) {
        return this.$store.dispatch('GETMEMOLIST', payload)
        .then(result =>{
          this.memo.listData = result
        })
      },
      getChecked_data(checked_data){
        const keys = Object.keys(checked_data)
        return keys.filter(key =>{
          return checked_data[key] == true
        }).map(result =>{
          return {id: result}
        })
      },
      getAlbum(id){
        return this.$store.dispatch('GETALBUM', id)
        .then(result =>{
          return result
        })
      },
      delete_advancepayment_albums(id) {
        const listData = this.advancepayment.data.offsetting_albums.listData
        this.advancepayment.data.offsetting_albums.listData = listData.filter(result =>{
          return result.id != id
        })
      },
      getAdvancepayment_file(payload){
        return this.$store.dispatch('GETADVANCEPAYMENT_FILE', payload)
        .then(result =>{
          return result
        })
      },
      objectCompare(targetObj , subObj2) {
        return targetObj.map(t_obj =>{
          return t_obj.id
        }).filter(t_obj =>{
          return !subObj2.map(s_obj =>{
                  return s_obj.id
                }).includes(t_obj)
        })
      },
      closeOpen(modalNo){
        return new Promise(resolve =>{
          resolve(this.modals[modalNo] = false)
        })
      },
      cancel(){
        this.confirm({
          title : '취소 확인',
          msg : `
            정말 나가시겠습니까?
          `,
          action : ()=>{
              this.$router.push({path: '/member'})
          }
        })
      },
      managerCall(){
            this.loadingShow()
            const option = {
                sort: 'admin_nickname',
                sortorder: 'asc',
                page: 0 ,
                limit: 100,
            }
            option['state'] = 'verified'
            option['role'] = 'admin'
            this.$store.dispatch('GETUSER', option)
            .then(result =>{
              this.loadingHide()
                this.managerList = [
                    ...result.items
                 
                ]
            }).catch(error=>{
                this.loadingHide()
                const status = error.response.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                    this.alert({msg:error.response.data.message })
                    break;
                }
                
            })
        },
    }
}
</script>

<style scoped>

</style>